import { Injectable } from '@angular/core';
import { ResponseResultComponent } from '../../shared/components/response-result/response-result.component';
import { DialogService } from 'primeng/dynamicdialog';
import { ConfirmationModalComponent } from '../../shared/components/confirmation-modal/confirmation-modal.component';

@Injectable({
  providedIn: 'root',
})
export class UtilsService {
  constructor(public dialogService: DialogService) {}
  showResponseResult(message: string, status: string) {
    return this.dialogService.open(ResponseResultComponent, {
      closable: false,
      data: {
        message: message,
        status: status,
      },
    });
  }

  showConfirmationModal(message: string) {
    return this.dialogService.open(ConfirmationModalComponent, {
      closable: false,
      data: {
        message: message,
      },
    });
  }
}
